<script>
    export default{
        data(){
            return{

            }
        },
        props: {
            line : Object
        },
    }
</script>

<template>
	<div class="modal fade" :id="line.idmodal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="myModalLabel">{{ line.tituloservico }}</h4>
                        </div>
                        <div class="modal-body">
                            <p>{{ line.modaltexto }}</p>
                            <hr style="border-top: 2px solid #cecece;">
                            <div class="panel-group" :id="line.idaccordion" role="tablist" aria-multiselectable="true">
                                <div class="panel panel-default" v-for="info in line.modalperguntas">
                                    <div class="panel-heading" role="tab" id="headingOne">
                                        <h4 class="panel-title">
                                            <a class="collapsed" role="button" data-toggle="collapse" :data-parent="info.idaccPergun" :href="info.hrefprgunta" aria-expanded="false" :aria-controls="info.ariacontrols">
                                                {{ info.pergunta }}
                                            </a>
                                        </h4>
                                    </div>
                                    <div :id="info.idresposta" class="panel-collapse collapse" role="tabpanel" :aria-labelledby="info.arialabel">
                                        <div class="panel-body">
                                            {{ info.resposta }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <a class="btn btn-border close-modal" data-dismiss="modal">Fechar</a>
                        </div>
                    </div>
                </div>
            </div>
</template>

<style scoped>
    .btn.btn-border{
            padding: 4px 14px;
    }

    .btn.btn-border:hover{
        border-color: #29b6f6;
    }
    
</style>


// WEBPACK FOOTER //
// modal.vue?5ac07af4